<header class="batches-index-header">
  <div class="batches-index-header-block">
    <span class="batches-index-header-title">
      {{ 'BATCH_MAILING.TITLE' | translate }}
    </span>
    <a
      target="_blank"
      aria-labelledby="batch-mailing-title"
      href="https://belpost.by/biznesu/Drugiyeuslugi/Oformleniyepartionnykhpoc"
    >
      {{ 'BATCH_MAILING.LINK_TO_RECOMMENDATIONS' | translate }}
    </a>
  </div>
  <app-main-tabs></app-main-tabs>
</header>
<div
  class="contact-book-container"
  *ngIf="configuration$ | async as configuration"
>
  <bw-contact-book [config]="configuration"></bw-contact-book>
</div>
